export interface VulnerabilitiesAppWebComponentSchema {
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnIndexes {
  COMPANY = 0,
  NAME = 1,
  RISK_SCORE = 2,
  CVES = 3,
  AFFECTED_DEVICES = 4,
  OS = 5,
  APPLICATION_TYPE = 6,
  STATE = 7,
  EXPLOITS = 8,
  TARGETS_YOUR_INDUSTRY = 9,
  AFFECTED_DEVICES_TYPE = 10,
  WATCHLIST = 11,
  SELECT = 12,
  SOURCE = 13,
}

export enum ColumnKeys {
  NAME = 'fullApplicationName',
  RISK_SCORE = 'scoreBreakdown.finalScore',
  CVES = 'cves',
  AFFECTED_DEVICES = 'affectedDevices',
  COMPANY = 'companyId',
  STATE = 'state',
  OS = 'operatingSystem',
  APPLICATION_TYPE = 'type',
  EXPLOITS = 'isExploitable',
  TARGETS_YOUR_INDUSTRY = 'isIndustryTargeted',
  AFFECTED_DEVICES_TYPE = 'affectedDevices.type',
  WATCHLIST = 'watchlist',
  SELECT = 'select',
  SOURCE = 'source',
}

export enum ApplicationType {
  OS = 1,
  APPLICATION = 2,
  SERVICES = 3,
}

export enum AnswerType {
  YES = 1,
  NO = 2,
}

export enum VulnerabilitiesSources {
  ENDPOINT = 1,
  NSVA = 2,
}
